import React from "react";
import { AuthProvider } from "./context/AuthContext";
import { Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import AppLayout from "./layouts/AppLayout";
import LoginLayout from "./layouts/LoginLayout";
import ScreenSizeRestrict from "./components/ScreenSizeRestrict";
import theme from "./ThemeFile";
import { ThemeProvider } from "@mui/material";
import CombinedProvider from "./providers";
import { LoaderProvider } from "./providers/LoaderProvider";

function App() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>AIMS Assessment Result Summary</title>
        <link rel="icon" type="image/png" href="" />
      </Helmet>
      <ScreenSizeRestrict />
      <LoaderProvider>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <CombinedProvider>
              <Switch>
                <Route path="/patients" component={AppLayout} />
                <Route path="*" component={LoginLayout} />
              </Switch>
            </CombinedProvider>
          </AuthProvider>
        </ThemeProvider>
      </LoaderProvider>
    </>
  );
}
export default App;
